import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Async thunk for fetching invoices
export const fetchInvoices = createAsyncThunk(
    "invoice/fetch",
    async ({ endDate, startDate }, { rejectWithValue }) => {
        try {
            // Call the API to fetch invoices
            const response = await request({
                endpoint: "/admin/getInvoices", // API endpoint
                method: "GET",
                params: { startDate, endDate }
            });

            console.log("Fetch Invoices Response:", response);

            // Check if the fetch operation was successful
            if (!response.data || !Array.isArray(response.data)) {
                return rejectWithValue(response.message || "Failed to fetch invoices.");
            }

            // Return the fetched invoices
            return response.data;
        } catch ({ error }) {
            console.error("Error fetching invoices:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching invoices.");
        }
    }
);

const initialState = {
    invoices: [], // Array to store all invoices
    loading: false,
    error: null,
};

const invoiceSlice = createSlice({
    name: "invoice",
    initialState,
    reducers: {
        addInvoices: (state, action) => {
            state.invoices = action.payload;
        },
        clearInvoices: (state) => {
            state.invoices = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Invoices
            .addCase(fetchInvoices.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInvoices.fulfilled, (state, action) => {
                state.loading = false;
                state.invoices = action.payload; // Update the invoices array
            })
            .addCase(fetchInvoices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            });
    },
});

export const { clearInvoices, addInvoices } = invoiceSlice.actions;
export default invoiceSlice.reducer;